<template>
    <v-container fluid>
      <v-card class="pa-8">
        <div class="d-flex align-center mb-8">
          <DateFilter ref="dateFilter" :minusDaysForStartDate="30" />
          <v-select
            v-model="selectedSoftware"
            :items="softwareItems"
            label="Выберите модуль"
            item-text="text"
            item-value="value"
            outlined
            hide-details
            class="ml-4"
            style="width: 1500px !important;"
          ></v-select>
          <v-btn
            @click="applySelection"
            variant="flat"
            color="green"
            dark
            class="ml-4"
          >
            Применить фильтр
          </v-btn>
          <v-btn
            @click="createExcel"
            variant="flat"
            :color="hasData ? 'green' : 'grey'"
            dark
            class="ml-4"
          >
            Выгрузить в xlsx
          </v-btn>
        </div>
        
        <v-card v-if="!loading" class="mb-8">
          <LineChart :chartXData="getNames" :chartYData="getSeries" straightLine></LineChart>
        </v-card>
        <v-card v-else>
          <v-card-text>Данные отсутствуют</v-card-text>
        </v-card>
  
        <v-card v-if="!loading">
          <Table :headersTable="tableHeaders" :itemsTable="tableItems" :search="true" />
        </v-card>
      </v-card>
    </v-container>
  </template>
  
  
  <script>
  import { mapActions, mapGetters, mapMutations } from "vuex";
  import axios from "axios";
  import Table from "./Software/Table.vue";
  import LineChart from './Software/LineChart.vue';
  import DateFilter from './DateFilter.vue';
  //   import SOFTWARE_CODES from '../../constants.js';
  
  export default {
    components: {
      DateFilter,
      LineChart,
      Table,
    },
    watch: {
      analyticsData: {
        handler() {
          this.hasData = this.analyticsData.length !== 0;
          this.showChartTable = this.analyticsData.length !== 0;
        },
      },
    },
    data() {
      const today = new Date();
      const beginDate = new Date();
      beginDate.setDate(today.getDate() - 30);
  
      return {
        dateBegin: beginDate.toISOString().substring(0, 10),
        dateEnd: today.toISOString().substring(0, 10),
        hasData: null,
        showChartTable: null,
        
        selectedSoftware: null,
        softwareItems: [],
        loading: true,
        tableHeaders: [],
        tableItems: [],
      };
    },
    computed: {
      ...mapGetters([
        "seriesNamesDetail",
        "chartSeriesDetail",
        "analyticsData",
        "softwareData",
        "url",
      ]),
      getNames() {
        return this.seriesNamesDetail;
      },
      getSeries() {
        return this.chartSeriesDetail;
      },
    },
    async created() {
      await this.createSoftwareData();
      this.prepareSoftwareItems();
    },
    methods: {
      ...mapActions([
        "createAnalyticsData",
        "createBusinessMetricsDetail",
        "createSoftwareData",
        "createExcelFile",
      ]),
      ...mapMutations(['setSnackbar']),
      formatDate(date) {
        if (!date) return null;
        const [year, month, day] = date.split("-");
        return `${day}-${month}-${year}`;
      },
      parseDate(date) {
        if (!date) return null;
        const [day, month, year] = date.split("-");
        return `${year}-${month}-${day}`;
      },
      prepareSoftwareItems() {
        this.softwareItems = Object.keys(this.softwareData).map(key => ({
          text: this.softwareData[key],
          value: key,
        }));
      },
      async applySelection() {
        this.tableHeaders = [];
        this.tableItems = [];
        this.dateBegin = this.$refs.dateFilter.getDateBegin();
        this.dateEnd = this.$refs.dateFilter.getDateEnd();
        let r;
        if (this.selectedSoftware) {
          this.loading = true;
          try {
            r = await this.createBusinessMetricsDetail({
              dateBegin: this.dateBegin,
              dateEnd: this.dateEnd,
              data: [this.selectedSoftware],
            });

            if (r) {
              const users = new Set();
              Object.values(r).forEach(innerObj => {
                Object.keys(innerObj).forEach(user => users.add(user));
              });

              this.tableHeaders.push({ text: "Метод", value: "method", sortable: true });
              [...users].forEach(user => {
                this.tableHeaders.push({
                  text: user,
                  value: user,
                  align: "center",
                  sortable: false,
                });
              });
              this.tableItems = Object.entries(r).map(([method, values]) => {
                return {
                  method,
                  ...values,
                };
              });

              this.loading = false;
            }
          } catch (e) {
            console.error(e);
          }
        }
      },
      async createExcel() {
        if (this.tableHeaders.length !== 0 && this.tableItems !== 0) {
          try {
            const data = {
              "headers": this.tableHeaders,
              "body": this.tableItems
            };
            const response = await axios.post(
              this.url + "reports",
              data,
              {
                responseType: "blob",
              }
            );
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Базовые метрики (детально) - ${this.selectedSoftware}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } catch (error) {
            const snackbar = {
              show: true,
              message: error,
              color: 'error'
            };
            this.setSnackbar(snackbar);
            console.error("Ошибка при загрузке файла:", error);
          }
        }
      },
      createTableArray() {
        const data = [{ text: "Дата", sortable: false, value: "date" }];
        for (const key in this.softwareData) {
          const softName = this.softwareData[key];
          data.push({ text: softName, sortable: false, value: softName });
        }
        return data;
      },
    },
  };
  </script>
  
  
  <style scoped>
  .no-data-message {
    text-align: center;
    padding: 20px;
  }
  </style>